require('./admin-panel/main');
require('./app/main');
require('./admin-panel/components/wheel-horizontal-scroll');

let app = document.getElementById("app");
if(app) {
    const app = new Vue({
        el: '#app'
    });
}
